import React, { useState } from 'react';
import { API_BASE_URL } from './config';
import fantasyLogo from './assets/jerseys/Logo 36.png';

const API_URL = `${API_BASE_URL}/api/fantasy-teams`;

const CreateTeamPage: React.FC<{ onTeamCreated: () => void }> = ({ onTeamCreated }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    
    if (!name.trim()) {
      setError('El nombre del equipo es obligatorio');
      return;
    }
    
    setLoading(true);
    
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ name }),
      });
      
      if (res.ok) {
        const data = await res.json();
        setSuccess('¡Equipo creado exitosamente!');
        if (data && data.id) {
          localStorage.setItem('fantasyTeamId', data.id);
        }
        setTimeout(() => {
          onTeamCreated();
        }, 1200);
      } else {
        const data = await res.json();
        setError(data.error || 'Error al crear el equipo');
      }
    } catch (err) {
      setError('Error de red');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#001A3E' }}>
      <div className="w-full max-w-md">
        {/* Logo and Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl mb-4 shadow-lg overflow-hidden" style={{ background: 'rgba(255,255,255,0.08)' }}>
            <img src={fantasyLogo} alt="FantasyLub Logo" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-3xl font-black text-white mb-1 tracking-tight">
            Fantasy<span style={{ color: '#FFB800' }}>Lub</span>
          </h1>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
            Fantasy de la Liga Uruguaya de Básquetbol
          </p>
        </div>

        {/* Create Team Card */}
        <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="text-center mb-6">
            <h2 className="text-xl font-black text-white mb-1">Creá tu Equipo</h2>
            <p className="text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Elegí un nombre para tu fantasy team
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-bold uppercase tracking-widest mb-2" style={{ color: 'rgba(255,255,255,0.5)' }}>
                Nombre del equipo
              </label>
              <input
                type="text"
                className="w-full px-4 py-3 rounded-xl text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-lub-accent transition-all"
                style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)' }}
                placeholder="Ej: Los Invencibles"
                value={name}
                onChange={e => setName(e.target.value)}
                required
              />
            </div>

            {error && (
              <div className="rounded-xl px-4 py-3 text-sm font-medium" style={{ background: 'rgba(248,113,113,0.12)', border: '1px solid rgba(248,113,113,0.25)', color: '#fca5a5' }}>
                {error}
              </div>
            )}

            {success && (
              <div className="rounded-xl px-4 py-3 text-sm font-medium" style={{ background: 'rgba(74,222,128,0.12)', border: '1px solid rgba(74,222,128,0.25)', color: '#4ade80' }}>
                {success}
              </div>
            )}

            <button
              type="submit"
              className="w-full font-black py-3 px-6 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed text-sm uppercase tracking-widest"
              style={{ background: '#FFB800', color: '#001A3E' }}
              disabled={loading}
            >
              {loading ? 'Creando...' : 'Crear Equipo'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateTeamPage; 